import {
  DEFAULT,
  ERROR,
  FORBIDDEN,
  LOADING,
  NETWORK_ISSUE,
  NOT_FOUND,
} from '../../api/api';
import { Section } from './Section';

interface IParams {
  result:
    ERROR | LOADING | NOT_FOUND | DEFAULT | NETWORK_ISSUE | FORBIDDEN;
}

export const Fallback = ({ result }: IParams) => {
  if (result.status === 'Loading') {
    return <div>Loading</div>;
  }
  if (result.status === 'Forbidden') {
    return (
      <div>
        <div>Forbidden</div>
        <div>You don't have permission to view this.</div>
      </div>
    );
  }
  if (
    result.status === 'Error' ||
    result.status === 'Not Found' ||
    result.status === 'Network issue'
  ) {
    return (
      <div>
        <div>{result.status}</div>
        <div>
          {result.errorMessages.map((e, i) => {
            return <div key={i}>{e}</div>;
          })}
        </div>
      </div>
    );
  }
  return <div>Inital</div>;
};

export const FallbackSection = ({ result }: IParams) => {
  if (result.status === 'Loading') {
    return (
      <Section>
        <div>Loading</div>
      </Section>
    );
  }
  if (result.status === 'Forbidden') {
    return (
      <Section>
        <div>
          <div>Forbidden</div>
          <div>You don't have permission to view this.</div>
        </div>
      </Section>
    );
  }
  if (
    result.status === 'Error' ||
    result.status === 'Not Found' ||
    result.status === 'Network issue'
  ) {
    return (
      <Section>
        <div>
          <div>{result.status}</div>
          <div>
            {result.errorMessages.map((e, i) => {
              return <div key={i}>{e}</div>;
            })}
          </div>
        </div>
      </Section>
    );
  }
  return (
    <Section>
      <div>Inital</div>
    </Section>
  );
};
